/* NOMI v23.41: scroll driver for nomi-table.css (hanging logo tab, photo deck, curtain reveal, grow photos).
   One rAF-throttled scroll handler writes CSS variables; nothing is hidden without it. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  var decks = [], curtains = [], grows = [], plx = [], drift = [];

  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return 1 - Math.pow(1 - t, 3); }

  function setupDeck(deck) {
    var cards = Array.prototype.slice.call(deck.querySelectorAll('.nt-card'));
    var cap = deck.querySelector('[data-nt-cap]');
    var num = deck.querySelector('[data-nt-num]');
    deck.style.setProperty('--nt-n', cards.length);
    // resting pose: a loose pile, each card a little rotated and offset
    var pose = [[-4, 0, 0], [5, 14, -8], [-8, -18, 10], [7, 20, 14], [-3, -10, -14], [9, 6, 18], [-6, 16, -4], [4, -14, 6]];
    cards.forEach(function (c, i) {
      var p = pose[i % pose.length];
      c._r = p[0]; c._x = p[1]; c._y = p[2];
      c.style.zIndex = cards.length - i;
    });
    decks.push({ el: deck, cards: cards, cap: cap, num: num, last: -1 });
    // the pile only reads as a pile if every photo is decoded: start loading them all well before it arrives
    var imgs = deck.querySelectorAll('img');
    var go = function () { Array.prototype.forEach.call(imgs, function (im) { im.loading = 'eager'; }); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { go(); io.disconnect(); } }, { rootMargin: '200% 0px' });
      io.observe(deck);
    } else go();
  }

  /* v23.45: site-wide photo parallax, after the Don Molinico site. Every cover photo that sits inside a
     clipping frame drifts a little slower than the page, so pictures keep moving as you scroll. Uses the
     individual `translate`/`scale` properties so it stacks on any existing transform. Photos that already
     have their own scroll motion (inner-page .ni-plx, the deck, the idle screen) are skipped. */
  function clips(el) {
    for (var n = el.parentElement, d = 0; n && d < 3; n = n.parentElement, d++) {
      var o = getComputedStyle(n);
      if (/(hidden|clip)/.test(o.overflow + o.overflowY) || o.clipPath !== 'none') return n;
    }
    return null;
  }
  function setupParallax() {
    var skip = '[data-nt-deck], .nomi-idle, .nomi-nav-header, .nomi-nav-tab, .nh-card-art, .ni-product-art, .ni-flavor-art, [data-no-plx]';
    Array.prototype.forEach.call(document.querySelectorAll('main img, main video, #MainContent img, #MainContent video'), function (el) {
      if (el._plx || el.classList.contains('ni-plx') || el.closest(skip)) return;
      var cs = getComputedStyle(el);
      if (cs.objectFit !== 'cover' || cs.translate !== 'none' || cs.scale !== 'none') return;
      if (el.offsetWidth < 260 || el.offsetHeight < 200) return;
      var box = clips(el); if (!box) return;
      el._plx = true;
      el.style.scale = '1.12';
      plx.push({ el: el, box: box, amt: el.closest('.nt-grow') ? 0.04 : 0.05 });
    });
  }
  /* cards in the product grids float at slightly different speeds (odd ones lag, even ones lead) */
  function setupDrift() {
    Array.prototype.forEach.call(document.querySelectorAll('.nh-cards > .nh-card, .ni-products > .ni-product'), function (c, i) {
      drift.push({ el: c, k: (i % 2 ? 1 : -1) * (i % 3 === 2 ? 0.05 : 0.035) });
    });
  }

  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    var narrow = window.innerWidth <= 820;
    root.classList.toggle('nt-scrolled', window.scrollY > 80);
    if (reduce) return;

    decks.forEach(function (d) {
      var r = d.el.getBoundingClientRect();
      var travel = r.height - vh;
      var p = travel > 0 ? clamp(-r.top / travel) : 0;
      var n = d.cards.length;
      var pos = p * (n - 1);                       // which card is on top (fractional)
      var top = Math.min(n - 1, Math.round(pos));
      d.cards.forEach(function (c, i) {
        var t = pos - i;                            // >0: this card is leaving / gone
        var tx, ty, rot, sc;
        if (t >= 0) {                               // peel away up and to the side
          var k = ease(clamp(t));
          tx = (c._x + (narrow ? 125 : (i % 2 ? 55 : 30)) * k) + '%';
          ty = (c._y - (narrow ? 20 : 125) * k) + '%';
          rot = c._r + (i % 2 ? 16 : 9) * k;
          sc = 1 - 0.06 * k;
        } else {                                    // waiting in the pile, settling as it nears the top
          var depth = Math.min(3, -t);
          tx = c._x * (0.35 + depth * 0.1) + 'px';
          ty = (c._y * 0.35 + depth * 10) + 'px';
          rot = c._r * (0.6 + depth * 0.2);
          sc = 1 - depth * 0.04;
        }
        c.style.setProperty('--tx', tx);
        c.style.setProperty('--ty', ty);
        c.style.setProperty('--rot', rot.toFixed(2) + 'deg');
        c.style.setProperty('--sc', sc.toFixed(3));
      });
      if (top !== d.last) {
        d.last = top;
        if (d.cap) d.cap.textContent = d.cards[top].getAttribute('data-cap') || '';
        if (d.num) d.num.textContent = String(top + 1).padStart(2, '0');
      }
    });

    curtains.forEach(function (c) {
      var r = c.getBoundingClientRect();
      // closed when the top edge enters the bottom of the screen, fully open by the time it's centred
      var p = clamp((vh * 0.8 - r.top) / (vh * 0.55));
      c.style.setProperty('--open', (p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2).toFixed(3));
    });

    plx.forEach(function (o) {
      if (o.off) return;
      // photos driven by the homepage GSAP timelines already move; GSAP clears translate/scale, so step aside
      if (o.el.style.transform && o.el.style.transform !== 'none') { o.off = true; o.el.style.scale = ''; o.el.style.translate = ''; return; }
      var r = o.box.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / vh));   // -1 (above) .. 1 (below)
      o.el.style.translate = '0 ' + (p * o.amt * 100).toFixed(2) + '%';
    });

    var wide = window.innerWidth > 900;
    drift.forEach(function (d) {
      if (!wide) { d.el.style.translate = ''; return; }
      var r = d.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var off = (r.top + r.height / 2 - vh / 2) * d.k;
      d.el.style.translate = '0 ' + Math.max(-36, Math.min(36, off)).toFixed(1) + 'px';
    });

    grows.forEach(function (g) {
      var r = g.getBoundingClientRect();
      var p = clamp((vh - r.top) / (vh * 0.85));
      g.style.setProperty('--g', ease(p).toFixed(3));
    });
  }

  var ticking = false;
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nt-deck]'), setupDeck);
    curtains = Array.prototype.slice.call(document.querySelectorAll('[data-nt-curtain]'));
    grows = Array.prototype.slice.call(document.querySelectorAll('[data-nt-grow]'));
    if (!reduce && window.innerWidth > 820) { setupParallax(); setupDrift(); } /* v23.65: phones scroll natively, no parallax */
    if (!reduce) {
      curtains.forEach(function (c) { c.style.setProperty('--open', 0); });
    grows.forEach(function (g) { g.style.setProperty('--g', 0); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (!reduce && window.innerWidth > 820) window.addEventListener('load', function () { setupParallax(); onScroll(); });
    frame();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
